module.exports = __webpack_public_path__ + "static/hochzeitsreisen-b565b087d9073a9ca22ba7c41453cb57.svg";